import { styled } from 'styled-components';

import { CommonAction, recipesCommonAction } from '@pkg/primitives';

export const MobileWrapper = styled.div``;

export const Row = styled.div`
    display: flex;
    gap: 10px;
`;

export const SearchWrapper = styled.div`
    flex: 1 1 auto;
`;

export const FixedBottom = styled.div`
    pointer-events: none;
    z-index: 1;
    position: fixed;
    bottom: 80px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    button {
        pointer-events: all;
    }
`;

export const SelectAllAction = styled(CommonAction)`
    ${recipesCommonAction.blur};
    padding-left: 16px;
    padding-right: 16px;
    height: 40px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;
